








import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import JobListItem from "../../../api/dataSource/api/EducationSystem/PublicWeb/Api/Models/EmployeeModels/JobListItem";
@Component
export default class EmployeeJobsComponent extends Vue {
  @Prop()
  jobs: Array<JobListItem>;
}
